var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C1.44772 9 1 8.55228 1 8C1 7.44771 1.44772 7 2 7H14C14.5523 7 15 7.44771 15 8C15 8.55228 14.5523 9 14 9L2 9Z",
    fill: "#303141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14C1.44772 14 1 13.5523 1 13C1 12.4477 1.44772 12 2 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14L2 14Z",
    fill: "#303141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C1.44772 4 1 3.55228 1 3C1 2.44771 1.44772 2 2 2L14 2C14.5523 2 15 2.44771 15 3C15 3.55228 14.5523 4 14 4L2 4Z",
    fill: "#303141"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.ca39ea731b82686f71f2141834f83fbc.svg";
export { ForwardRef as ReactComponent };